import { Theme } from "@mui/material";

const useStyles = (theme: Theme) => ({
  boxContainer: (direction: "row" | "column") => ({
    display: "flex",
    flexDirection: direction,
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    height: "100%",
    overflow: "hidden",
    position: "relative",
  }),
  boxCircularAndText: (boxHeight: number | null, boxWidth: number | null) => ({
    display: "flex",
    gap: 2,
    alignItems: "center",
    justifyContent: "center",
    height: boxHeight,
    width: boxWidth,
    overflow: "hidden",
    flexShrink: 1,
    flexDirection: "row", // ou "column" se for vertical, pode receber como parâmetro se quiser
  }),
  boxTextCenter: (height: number) => ({
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    position: "absolute",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: height + "px",
    width: height + "px",
  }),
  boxText: (direction: "column" | "row") => ({
    display: "flex",
    flexDirection: "column",
    alignItems: "start",
    justifyContent: "center",
    width: direction === "row" ? "100%" : 100,
    overflow: "hidden",
  }),
  boxTextsValues: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: 1,
  },
  symbolBox: (background: string | undefined) => ({
    width: 4,
    height: 18,
    borderRadius: "30px",
    backgroundColor: background,
    flexShrink: 0,
  }),
});

export default useStyles;
